var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConsultActiveTabIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.42898 8.37131C1.92407 8.37131 1.51477 7.962 1.51477 7.4571V6.5429C1.51477 6.03799 1.92407 5.62869 2.42898 5.62869L5.62869 5.62778V2.42897C5.62869 1.92407 6.038 1.51477 6.5429 1.51477H7.4571C7.962 1.51477 8.37131 1.92407 8.37131 2.42897V5.62869H11.571C12.0759 5.62869 12.4852 6.03799 12.4852 6.5429V7.4571C12.4852 7.962 12.0759 8.37131 11.571 8.37131H8.37131V11.571C8.37131 12.0759 7.962 12.4852 7.4571 12.4852H6.5429C6.038 12.4852 5.62869 12.0759 5.62869 11.571V8.37039L2.42898 8.37131ZM4.44726 9.55216L2.42931 9.55274C1.27192 9.55274 0.333336 8.61449 0.333336 7.4571V6.5429C0.333336 5.38562 1.2714 4.44744 2.42864 4.44726C2.42875 4.44726 2.42853 4.44726 2.42864 4.44726L4.44726 4.44668V2.42897C4.44726 1.27158 5.38551 0.333332 6.5429 0.333332H7.4571C8.61449 0.333332 9.55274 1.27158 9.55274 2.42897V4.44726H11.571C12.7284 4.44726 13.6667 5.38551 13.6667 6.5429V7.4571C13.6667 8.61449 12.7284 9.55274 11.571 9.55274H9.55274V11.571C9.55274 12.7284 8.61449 13.6667 7.4571 13.6667H6.5429C5.38551 13.6667 4.44726 12.7284 4.44726 11.571V9.55216Z",
    fill: "#4F34D2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsultActiveTabIcon);
export default __webpack_public_path__ + "static/media/consult-active-tab-icon.285f8c551fff3e612bc9463bc27862d6.svg";
export { ForwardRef as ReactComponent };